// DBC-style text generation for signals, kept in sync with the same
// bit-mapping/decode logic used elsewhere (no independent re-derivation of
// the numeric fields).

// Rounds away float noise (e.g. 0.1 + 0.2) and normalizes -0, without
// forcing a fixed decimal count on values that don't need it.
function trimNumber(n) {
  const rounded = Math.round(n * 1e6) / 1e6;
  return Object.is(rounded, -0) ? 0 : rounded;
}

export function buildDbcLine(signal) {
  const orderDigit = signal.byteOrder === 'motorola' ? 0 : 1;
  const signDigit = signal.signed ? '-' : '+';
  // Physical Min/Max are the signal's own documented range (editable in the
  // signal form), not re-derived from the raw bit range here — a signal's
  // valid engineering range is often narrower than what its bits could hold.
  const min = signal.physicalMin;
  const max = signal.physicalMax;
  const name = signal.name && signal.name.trim() ? signal.name.trim() : 'UnnamedSignal';
  return `SG_ ${name} : ${signal.startBit}|${signal.length}@${orderDigit}${signDigit} ` +
    `(${trimNumber(signal.factor)},${trimNumber(signal.offset)}) ` +
    `[${trimNumber(min)}|${trimNumber(max)}] "${signal.unit || ''}"`;
}

export function buildDbcBlock(canIdDecimal, dlc, signals) {
  const header = `BO_ ${canIdDecimal} CAN_Frame: ${dlc} Vector__XXX`;
  const lines = signals.map((s) => ' ' + buildDbcLine(s));
  return [header, ...lines].join('\n');
}
